export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Скачать JPG файл',
    downloadPDF: 'Скачать PDF файл',
    downloadPNG: 'Скачать PNG файл',
    downloadSVG: 'Скачать SVG файл',
    exportButtonTitle: 'Экспортировать',
    forexRate: 'Курс валют FOREX',
    loading: 'Загрузка...',
    months: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
    printButtonTitle: 'Печатать',
    rangeSelectorFrom: 'С',
    rangeSelectorTo: 'До',
    rangeSelectorZoom: 'Приблизить',
    rateTypes: {
      ask: 'Лучшее предложение по продаже',
      bid: 'Лучшее предложение по покупке',
      forex: 'Средний курс в мире',
    },
    resetZoom: 'Восстановить',
    resetZoomTitle: 'Восстановить',
    shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    thousandsSep: ' ',
    weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    wtBestAsk: 'Лучшее предложение по продаже',
    wtBestBid: 'Лучшее предложение по покупке',
    seriesError: 'Необходимо выбрать хотя бы одну опцию',
  },
  calculator: {
    title: 'Рассчитайте экономию в Walutomat',
    forBuy: 'для',
    unsupportedPair: 'В настоящее время мы не предлагаем курсы для выбранной валютной пары.',
    spinnerError: {
      generic: 'Возникла проблема с загрузкой данных',
      toManyRequests:
        'Калькулятор в настоящее время недоступен. Попробуйте позже или обратитесь в <a href="https://www.walutomat.com/ru/kontakt/">службу поддержки клиентов</a>.',
    },
    commissionWT: 'Комиссия Walutomat',
    ctaButton: 'Обменять',
    amountText: 'Сумма',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Проверь курсы и{{nbsp}}обменяй валюту в{{nbsp}}Walutomat – быстро и{{nbsp}}выгодно.',
    actualRate: 'Текущий обменный курс',
    buySelect: 'Покупаю',
    sellSelect: 'Продаю',
    exchangeAmountSellLabel: 'Вы получите',
    exchangeAmountBuyLabel: 'Внесите',
    commission: 'Промо-комиссия ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Поле, обязательное для заполнения',
    requiredField: 'Поле, обязательное для заполнения',
    requireAllFields: 'Все поля должны быть заполнены',
    passwordToShort: 'Поле должно состоять из 8 символов',
    emailNotValid: 'Aдрес email неправильный',
    emailReserved: 'Данный email уже существует',
    emailUnregistered: 'Не найдено адреса электронной почты в нашей базе клиентов.',
    markField: 'Отметьте хотя бы один из флажков',
    serverUnknownError: 'Ошибка связи с сервером',
    invalidCharacters: 'Поле содержит недопустимые символы',
    phoneNotValid: 'Номер телефона неверен',
    checkBoxBelow: 'Пожалуйста, отметьте поле ниже, чтобы отправить сообщение',
    promocodeInvalid: 'Неправильный код рекламной акции',
    newsletterAlreadySubscribed: 'Этот адрес электронной почты уже подписан на рассылку новостей.',
    captchaError: 'Проверка не прошла. Попробуйте ещё раз.',
  },
  password: {
    show: 'Показать',
    hide: 'скрывать',
  },
  howItWorks: {
    showButton: 'Показать больше',
    hideButton: 'Показать меньше',
  },
  rateCalculator: {
    baseInputLabel: 'Mam',
    counterInputLabel: 'Otrzymam',
    counterInputTooltip: 'Uwzględnia prowizję {{commission}}%',
    ctaAlert: 'Ustaw alert',
  },
  esim: {
    searchPlaceholder: 'Поиск страны или региона...',
    searchAriaLabel: 'Поиск страны или региона',
    searchMinChars: 'Введите <b>не менее 3 символов</b> для отображения результатов.',
    searchNoResults: '<b>Результатов не найдено.</b> Искомая страна не найдена.',
    searchError: '<b>Произошла ошибка.</b> Не удалось загрузить список предложений.',
  },
  countries: {
    AD: 'Андорра',
    AE: 'Объединенные Арабские Эмираты',
    AF: 'Афганистан',
    AG: 'Антигуа и Барбуда',
    AI: 'Ангилья',
    AL: 'Албания',
    AM: 'Армения',
    AN: 'Нидерландские Антильские острова',
    AO: 'Ангола',
    AQ: 'Антарктида',
    AR: 'Аргентина',
    AS: 'Американское Самоа',
    AT: 'Австрия',
    AU: 'Австралия',
    AW: 'Аруба',
    AX: 'Аландские Острова',
    AZ: 'Азербайджан',
    BA: 'Босния и Герцеговина',
    BB: 'Барбадос',
    BD: 'Бангладеш',
    BE: 'Бельгия',
    BF: 'Буркина-Фасо',
    BG: 'Болгария',
    BH: 'Бахрейн',
    BI: 'Бурунди',
    BJ: 'Бенин',
    BL: 'Сен-Бартелеми',
    BM: 'Бермудские Острова',
    BN: 'Государство Бруней-Даруссалам',
    BO: 'Боливия',
    BQ: 'Бонайре',
    BR: 'Бразилия',
    BS: 'Багамы',
    BT: 'Бутан',
    BV: 'Остров Буве',
    BW: 'Ботсвана',
    BY: 'Беларусь',
    BZ: 'Белиз',
    CA: 'Канада',
    CC: 'Кокосовые Острова',
    CD: 'Демократическая Республика Конго',
    CF: 'Центральноафриканская Республика',
    CG: 'Конго',
    CH: 'Швейцария',
    CI: "Кот-д'Ивуар",
    CK: 'Острова Кука',
    CL: 'Чили',
    CM: 'Камерун',
    CN: 'Китай',
    CO: 'Колумбия',
    CR: 'Коста-Рика',
    CU: 'Куба',
    CV: 'Республика Кабо-Верде',
    CW: 'Кюрасао',
    CX: 'Остров Рождества',
    CY: 'Кипр',
    CZ: 'Чехия',
    DE: 'Германия',
    DJ: 'Джибути',
    DK: 'Дания',
    DM: 'Доминика',
    DO: 'Доминиканская Республика',
    DZ: 'Алжир',
    EC: 'Эквадор',
    EE: 'Эстония',
    EG: 'Египет',
    EH: 'Западная Сахара',
    ER: 'Эритрея',
    ES: 'Испания',
    ET: 'Эфиопия',
    FI: 'Финляндия',
    FJ: 'Фиджи',
    FK: 'Фолклендские острова',
    FM: 'Микронезия',
    FO: 'Фарерские Острова',
    FR: 'Франция',
    GA: 'Габон',
    GB: 'Великобритания',
    GD: 'Гренада',
    GE: 'Грузия',
    GF: 'Французская Гвиана',
    GG: 'Гернси',
    GH: 'Гана',
    GI: 'Гибралтар',
    GL: 'Гренландия',
    GM: 'Гамбия',
    GN: 'Гвинея',
    GP: 'Гваделупа',
    GQ: 'Экваториальная Гвинея',
    GR: 'Греция',
    GS: 'Южная Георгия и Южные Сандвичевы Острова',
    GT: 'Гватемала',
    GU: 'Гуам',
    GW: 'Гвинея-Бисау',
    GY: 'Гайана',
    HK: 'Гонконг',
    HM: 'Остров Херд и острова Макдональд',
    HN: 'Гондурас',
    HR: 'Хорватия',
    HT: 'Гаити',
    HU: 'Венгрия',
    ID: 'Индонезия',
    IE: 'Ирландия',
    IL: 'Израиль',
    IM: 'Остров Мэн',
    IN: 'Индия',
    IO: 'Британская территория в Индийском океане',
    IQ: 'Ирак',
    IR: 'Иран',
    IS: 'Исландия',
    IT: 'Италия',
    JE: 'Джерси',
    JM: 'Ямайка',
    JO: 'Иордания',
    JP: 'Япония',
    KE: 'Кения',
    KG: 'Кыргызстан',
    KH: 'Камбоджа',
    KI: 'Кирибати',
    KM: 'Коморы',
    KN: 'Сент-Китс и Невис',
    KP: 'Северная Корея',
    KR: 'Южная Корея',
    KW: 'Кувейт',
    KY: 'Острова Кайман',
    KZ: 'Казахстан',
    LA: 'Лаос',
    LB: 'Ливан',
    LC: 'Сент-Люсия',
    LI: 'Лихтенштейн',
    LK: 'Шри-Ланка',
    LR: 'Либерия',
    LS: 'Лесото',
    LT: 'Литва',
    LU: 'Люксембург',
    LV: 'Латвия',
    LY: 'Ливия',
    MA: 'Марокко',
    MC: 'Монако',
    MD: 'Молдова',
    ME: 'Черногория',
    MF: 'Сен-Мартен',
    MG: 'Мадагаскар',
    MH: 'Маршалловы Острова',
    MK: 'Северная Македония',
    ML: 'Мали',
    MM: 'Мьянма',
    MN: 'Монголия',
    MO: 'Макао',
    MP: 'Северные Марианские Острова',
    MQ: 'Мартиника',
    MR: 'Мавритания',
    MS: 'Монтсеррат',
    MT: 'Мальта',
    MU: 'Маврикий',
    MV: 'Мальдивы',
    MW: 'Малави',
    MX: 'Мексика',
    MY: 'Малайзия',
    MZ: 'Мозамбик',
    NA: 'Намибия',
    NC: 'Новая Каледония',
    NE: 'Нигер',
    NF: 'Норфолк',
    NG: 'Нигерия',
    NI: 'Никарагуа',
    NL: 'Нидерланды',
    NO: 'Норвегия',
    NP: 'Непал',
    NR: 'Науру',
    NU: 'Ниуэ',
    NZ: 'Новая Зеландия',
    OM: 'Оман',
    PA: 'Панама',
    PE: 'Перу',
    PF: 'Французская Полинезия',
    PG: 'Папуа-Новая Гвинея',
    PH: 'Филиппины',
    PK: 'Пакистан',
    PL: 'Польша',
    PM: 'Сен-Пьер и Микелон',
    PN: 'Острова Питкэрн',
    PR: 'Пуэрто-Рико',
    PS: 'Палестина',
    PT: 'Португалия',
    PW: 'Палау',
    PY: 'Парагвай',
    QA: 'Катар',
    RE: 'Реюньон',
    RO: 'Румыния',
    RS: 'Сербия',
    RU: 'Россия',
    RW: 'Руанда',
    SA: 'Саудовская Аравия',
    SB: 'Соломоновы Острова',
    SC: 'Сейшельские Острова',
    SD: 'Судан',
    SE: 'Швеция',
    SG: 'Сингапур',
    SH: 'Острова Святой Елены, Вознесения и Тристан-да-Кунья',
    SI: 'Словения',
    SJ: 'Шпицберген и Ян-Майен',
    SK: 'Словакия',
    SL: 'Сьерра-Леоне',
    SM: 'Сан-Марино',
    SN: 'Сенегал',
    SO: 'Сомали',
    SR: 'Суринам',
    SS: 'Южный Судан',
    ST: 'Сан-Томе и Принсипи',
    SV: 'Сальвадор',
    SX: 'Синт-Мартен',
    SY: 'Сирия',
    SZ: 'Эсватини',
    TC: 'Теркс и Кайкос',
    TD: 'Чад',
    TF: 'Французские Южные и Антарктические территории',
    TG: 'Того',
    TH: 'Таиланд',
    TJ: 'Таджикистан',
    TK: 'Токелау',
    TL: 'Восточный Тимор',
    TM: 'Туркменистан',
    TN: 'Тунис',
    TO: 'Тонга',
    TR: 'Турция',
    TT: 'Тринидад и Тобаго',
    TV: 'Тувалу',
    TW: 'Тайвань',
    TZ: 'Танзания',
    UA: 'Украина',
    UG: 'Уганда',
    UM: 'Внешние малые острова США',
    US: 'Соединенные Штаты Америки',
    UY: 'Уругвай',
    UZ: 'Узбекистан',
    VA: 'Ватикан',
    VC: 'Сент-Винсент и Гренадины',
    VE: 'Венесуэла',
    VG: 'Британские Виргинские Острова',
    VI: 'Виргинские Острова США',
    VN: 'Вьетнам',
    VU: 'Вануату',
    WF: 'Уоллис и Футуна',
    WS: 'Самоа',
    XK: 'Косово',
    YE: 'Йемен',
    YT: 'Майотта',
    ZA: 'Южная Африка',
    ZM: 'Замбия',
    ZW: 'Зимбабве',
  },
  trackingEvent: {
    buttonGooglePlay: 'Скачать из Google Play',
    buttonAppStore: 'Скачать из App Store',
  },
}
